<template>
  <main-layout ref="layout">
    <b-overlay :show="loading" class="mb-5 p-3">
      <expression-orale v-if="item.type === 2" :text="item"></expression-orale>
      <text-editor-teacher
          v-if="item.type === 3 && isTeacher"
          :item="item"/>
      <TextEditor ref="editor" v-else-if="item.type === 1" :item="item"></TextEditor>
    </b-overlay>
  </main-layout>
</template>

<script>
import TextEditor from "@/components/Textes/TextEditor";
import ExpressionOrale from "@/components/ExercicesComponents/expressionOrale";
import {Auth, Exercice, Textes} from "@/js/caller";
import TextEditorTeacher from "@/components/Textes/TextEditorTeacher";

export default {
  name      : "TexteVue",
  components: {TextEditorTeacher, ExpressionOrale, TextEditor},
  data() {
    return {
      loading: true,
      isTeacher: Auth.IsTeacher(),
      item   : {},
    }
  },
  methods: {
    updateStyle() {
      if (!this.$refs.editor) return;
      const top = this.$refs.layout.$refs.nav.$el.clientHeight
      const [toolbar] = document.getElementsByClassName('ql-toolbar');
      toolbar.style.top = `${top}px`
    }
  },
  created() {
    const {id} = this.$route.params
    Textes.Get(id).then(res => {
      this.item = res;
      //if (typeof item === 'object') this.item = {...this.item, ...item}
      return Exercice.Get(this.item.exercice).then((ex => this.exercice = ex));
    }).then(() => {
      this.loading = false;
    });
    window.onresize = () => {
      this.updateStyle();
    }
  },
  beforeUpdate() {
    this.updateStyle();
  }
}
</script>

<style scoped>

</style>